import React from 'react';

import i18next from 'i18next';

import { Button } from 'src/app/components/lib/button';
import { Divider } from 'src/app/components/lib/divider';
import { FormContainer, FormSection } from 'src/app/components/lib/form';
import { Heading } from 'src/app/components/lib/heading';
import { Input } from 'src/app/components/lib/input';
import { TabbedDetailsContainer } from 'src/app/components/lib/tabs/tabs-rebrand.styles';

import type { Tag } from 'src/app/queries/marketing/get-campaigns';

type MarketingTagDetailsProps = {
  isNew: boolean;
  isValid: () => boolean;
  navigateBack: () => void;
  onTagNameChange: (value: string) => void;
  onUpdateTag: () => void;
  selected: Tag;
  tagName: string;
};

export function MarketingTagDetails({
  isNew,
  isValid,
  navigateBack,
  onTagNameChange,
  onUpdateTag,
  selected,
  tagName,
}: MarketingTagDetailsProps) {
  return (
    <TabbedDetailsContainer>
      <Heading level={2} onBackAction={navigateBack}>
        {isNew ? i18next.t('Add tag') : selected?.TagName}
      </Heading>
      <FormContainer>
        <FormSection>
          <Input
            automationId='tables-marketing-tag-name'
            label='Tag name:'
            required
            value={tagName}
            onChange={({ target }) => {
              onTagNameChange(target.value);
            }}
          />
        </FormSection>
        <Divider variant='end-of-form' />
        <Button
          automationId='tables-marketing-tag-save-button'
          disabled={!isValid()}
          label='Save'
          variant='primary'
          onClick={onUpdateTag}
        />
      </FormContainer>
    </TabbedDetailsContainer>
  );
}
